import { render, staticRenderFns } from "./additional-travellers-combined-product-summary.vue?vue&type=template&id=b0c2deae&scoped=true"
import script from "./additional-travellers-combined-product-summary.vue?vue&type=script&setup=true&lang=ts"
export * from "./additional-travellers-combined-product-summary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./additional-travellers-combined-product-summary.vue?vue&type=style&index=0&id=b0c2deae&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c2deae",
  null
  
)

export default component.exports